import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-mb-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "p-mb-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_button = _resolveComponent("info-button")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, {
    collapsed: true,
    header: _ctx.$t('legend'),
    toggleable: true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Card, null, {
        content: _withCtx(() => [
          (_ctx.legendInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('legendInfo')), 1),
                _hoisted_3,
                _hoisted_4
              ]))
            : _createCommentVNode("", true),
          (_ctx.legendInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("b", null, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('legendSubtitle')), 1)
                ]),
                _hoisted_7
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legendItems, (item) => {
            return (_openBlock(), _createElementBlock("div", { key: item }, [
              _createVNode(_component_Button, {
                class: _normalizeClass([item.styleClass, "formBox"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_info_button),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(item.name)), 1)
                ]),
                _: 2
              }, 1032, ["class"])
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["header"]))
}